import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap-modal'
import { ajaxGet } from '../../ajax'
import UsualGame from './usual-game'
import SpecialGame from './special-game'
import BlockGame from './block-game'
import OpenGame from './open-game'
import History from './history'
import Cost from './cost'

function GameForm({ params, onClose, sdAdminLevel }) {
  const [payload, setPayload] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!payload) loadData()
  }, [payload])

  const loadData = () => {
    const defaultParams = {}
    if (params.field) defaultParams['game[field_ids][]'] = params.field
    if (params.date) defaultParams['game[date]'] = params.date
    if (params.default_time) defaultParams['game[default_time]'] = params.default_time

    setIsLoading(true)
    ajaxGet(`/admins/reservations/new.json?` + new URLSearchParams(defaultParams))
    .then(response => { if (response.ok) return response.json() })
    .then((json) => {
      setPayload(json)
      setIsLoading(false)
    })
  }

  const changeCost = (value) => {
    setPayload({...payload, cost: value})
  }
  
  if (!payload) return null
  const gameCost = parseFloat(payload.cost).toFixed(2)

  return <Modal dialogClassName='reservation-form-modal' container={document.body} show={true} onHide={onClose}>
    <Modal.Header closeButton>
      <Modal.Title>Create a New Reservation</Modal.Title>
    </Modal.Header>
    <ul className='nav nav-tabs'>
      <li role='presentation' className='active'>
        <a data-toggle='tab' href='#new-game-form'>New</a>
      </li>
      <li role='presentation'>
        <a data-toggle='tab' href='#new-game-history'>History</a>
      </li>
    </ul>
    <div className='tab-content'>
      <div id='new-game-form' className={'tab-pane fade in active' + (isLoading ? ' isLoading' : '')}>
        { isLoading && <div className='animated-spinner'></div> }
        <Modal.Body>
          <div className='row'>
            <div className='col-sm-12'>
              <ul className='nav nav-tabs'>
                <li role='presentation' className='active'>
                  <a data-toggle='tab' href='#with-player'>Client Name</a>
                </li>
                <li role='presentation'>
                  <a data-toggle='tab' href='#special-event'>Special</a>
                </li>
                <li role='presentation'>
                  <a data-toggle='tab' href='#block-field'>Block</a>
                </li>
                { payload.allow_open &&
                  <li role='presentation'>
                    <a data-toggle='tab' href='#open-game'>Open</a>
                  </li>
                }
              </ul>
              <div className='tab-content'>
                <div id='with-player' className='tab-pane fade in active'>
                  <UsualGame 
                    payload={payload}
                    onChangePayload={setPayload}
                    onCreate={onClose}
                    onLoading={setIsLoading}
                  />
                </div>
                <div id='special-event' className='tab-pane fade'>
                  <SpecialGame 
                    payload={payload}
                    onChangePayload={setPayload}
                    onCreate={onClose}
                    onLoading={setIsLoading}
                  />
                </div>
                <div id='block-field' className='tab-pane fade'>
                  <BlockGame
                    payload={payload}
                    onChangePayload={setPayload}
                    onCreate={onClose}
                    onLoading={setIsLoading}
                  />
                </div>
                { payload.allow_open &&
                  <div id='open-game' className='tab-pane fade'>
                    <OpenGame
                      payload={payload}
                      onChangePayload={setPayload}
                      onCreate={onClose}
                      onLoading={setIsLoading}
                    />
                  </div>
                }
              </div>
            </div>
          </div>
        </Modal.Body>
        <Cost currency={payload.currency} value={gameCost} priceEditable={payload.price_editable} onChange={changeCost} />
      </div>
      <div id='new-game-history' className='tab-pane fade'>
        <Modal.Body>
          <History events={payload.events} />
        </Modal.Body>
      </div>
    </div>
  </Modal>
}

GameForm.propTypes = {
  params: PropTypes.object,
  onClose: PropTypes.func.isRequired
}

export default GameForm
